export default "__VITE_ASSET__CE7Nn3dQ__"